import { commonPhotoSwipe } from './common_photo_swipe'

export default function(attributes) {
  return {
    el: '#app',
    data() {
      return {
      }
    },
    mixins: [commonPhotoSwipe],
    mounted() {
      const accordions = document.querySelectorAll('.accordion .tickets-header.accordion-label');
      accordions.forEach(function (clickedItem) {
        clickedItem.addEventListener('click', function () {
          clickedItem.parentNode.classList.toggle('is-active');
        });
      });
    }
  }
}

